import { apiGet } from "./http";

export interface MemberPointsBreakdownRow {
  memberLegacyId: string;
  activityRegistrationCount: number;
  pointsActivity: number;
  pointsVote: number;
  pointsSignin: number;
  pointsOther: number;
}

export function fetchMemberPointsBreakdown(tenantLegacyId: string) {
  return apiGet<MemberPointsBreakdownRow[]>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/stats/member-points-breakdown`
  );
}
